import React, { useMemo } from 'react';
import { number } from 'prop-types';
import Skeleton from 'react-loading-skeleton';

const ProductsTableLoader = ({ count = 3 }) => {
    const skeletonItems = useMemo(() => {
        const items = [];

        if (!count) {
            return items;
        }

        for (let i = 0; i < count; i += 1) {
            items.push(
                <div className="skeleton-loader-row" key={i}>
                    <div className="grid">
                        <div className="col-md-3">
                            <Skeleton
                                height={18}
                                width="90%"
                                style={{
                                    marginBottom: 25
                                }}
                            />
                        </div>
                        <div className="col-md-3">
                            <Skeleton
                                height={10}
                                style={{
                                    marginBottom: 8
                                }}
                            />
                            <Skeleton
                                height={10}
                                width="80%"
                                style={{
                                    marginBottom: 30
                                }}
                            />
                        </div>
                        <div className="col-md-6">
                            <Skeleton
                                height={10}
                                style={{
                                    marginBottom: 8
                                }}
                            />
                            <Skeleton
                                height={10}
                                style={{
                                    marginBottom: 8
                                }}
                            />
                            <Skeleton
                                height={10}
                                width="80%"
                                style={{
                                    marginBottom: 30
                                }}
                            />
                            <div className="skeleton-flex-container">
                                <Skeleton height={10} width={70} />
                                <Skeleton height={10} width={80} />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return items;
    }, []);

    return <React.Fragment>{skeletonItems.map(item => item)}</React.Fragment>;
};

ProductsTableLoader.propTypes = {
    count: number
};

export default ProductsTableLoader;
